import React from 'react'
import { Button, ButtonActionBar } from 'modules/core/components'
import { PlusCircleOutlined } from '@ant-design/icons'

const AddFormItem = ({ addData }) => {
  return (
    <>
      <ButtonActionBar position={'center'} className={'bc-button-action-bar-item'}>
        <Button.Primary
          icon={<PlusCircleOutlined />}
          onClick={addData.onClick}
          disabled={addData.disabled}
          title={addData.buttonName}
        />
      </ButtonActionBar>
    </>
  )
}
export default AddFormItem
